/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { StrictHttpResponse } from '../strict-http-response';
import { WeatherApiConfiguration } from '../weather-api-configuration';

import { GetProviders$Params, getProviders } from '../fn/provider/get-providers';
import { Provider } from '../models/provider';

/**
 * Provider API
 */
@Injectable({ providedIn: 'root' })
export class ProviderService extends BaseService {
   constructor(config: WeatherApiConfiguration, http: HttpClient) {
      super(config, http);
   }

   /** Path part for operation `getProviders()` */
   static readonly GetProvidersPath = '/api/weather/provider';

   /**
    * This method provides access to the full `HttpResponse`, allowing access to response headers.
    * To access only the response body, use `getProviders()` instead.
    *
    * This method doesn't expect any request body.
    */
   getProviders$Response(
      params?: GetProviders$Params,
      context?: HttpContext
   ): Observable<StrictHttpResponse<Provider>> {
      return getProviders(this.http, this.rootUrl, params, context);
   }

   /**
    * This method provides access only to the response body.
    * To access the full response (for headers, for example), `getProviders$Response()` instead.
    *
    * This method doesn't expect any request body.
    */
   getProviders(params?: GetProviders$Params, context?: HttpContext): Observable<Provider> {
      return this.getProviders$Response(params, context).pipe(
         map((r: StrictHttpResponse<Provider>): Provider => r.body)
      );
   }
}
